/**
 * @generated SignedSource<<75fed869b0d5908af8079ea6ba44e464>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TVAssigneesPopover_roles$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoleListItem_role">;
  readonly " $fragmentType": "TVAssigneesPopover_roles";
}>;
export type TVAssigneesPopover_roles$key = ReadonlyArray<{
  readonly " $data"?: TVAssigneesPopover_roles$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVAssigneesPopover_roles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TVAssigneesPopover_roles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleListItem_role"
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};

(node as any).hash = "d0697a7e1dc6567ddff7c09b4e966845";

export default node;
